import React from "react";

const TONE_CLASS = {
  success: "bg-success-focus text-success-main",
  warning: "bg-warning-focus text-warning-main",
  danger: "bg-danger-focus text-danger-main",
  info: "bg-info-focus text-info-main",
  secondary: "bg-neutral-200 text-secondary-light",
};

export function statusTone(value) {
  const text = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (
    [
      "verified",
      "active",
      "approved",
      "uploaded",
      "confirmed",
      "completed",
      "complete",
      "released",
      "success",
      "paid",
      "received",
      "issued",
      "available",
      "published",
      "ready",
      "assigned",
      "read",
      "resolved",
      "closed",
      "on_track",
      "met",
    ].includes(text)
  ) {
    return "success";
  }

  if (
    [
      "pending",
      "submitted",
      "under_review",
      "action_required",
      "processing",
      "in_progress",
      "draft",
      "unread",
      "on_hold",
      "not_published",
      "not_ready",
      "partial",
      "partially_paid",
      "partially_ready",
      "pending_verification",
      "payment_pending",
      "refund_pending",
      "overdue",
      "due_soon",
      "waiting_for_agent",
    ].includes(text)
  ) {
    return "warning";
  }

  if (
    [
      "rejected",
      "cancelled",
      "canceled",
      "sold_out",
      "locked",
      "failed",
      "inactive",
      "suspended",
      "danger",
      "missed",
    ].includes(text)
  ) {
    return "danger";
  }

  if (["info", "shipped", "open", "agency_admin", "booking_staff", "accountant", "from_package"].includes(text)) {
    return "info";
  }

  if (["required", "missing"].includes(text)) {
    return "secondary";
  }

  return "secondary";
}

export default function StatusBadge({ value, children, className = "" }) {
  const text = String(value || "unknown");
  const tone = statusTone(text);
  const label = children || text.replace(/_/g, " ");

  return (
    <span className={`${TONE_CLASS[tone] || TONE_CLASS.secondary} px-24 py-4 rounded-pill fw-medium text-sm text-capitalize agent-status-badge ${className}`.trim()}>
      {label}
    </span>
  );
}
